import React from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../hooks/use-stores';

function RequirePartnerAccess({ partnerId, children, fallback = null }) {
    const { authStore } = useStores();

    const hasAccess =
        authStore.currentUser?.super_admin ||
        authStore.currentUser?.superForAccounts?.some(
            (p) => p.id === Number(partnerId)
        );

    return hasAccess ? <>{children}</> : fallback;
}

export default observer(RequirePartnerAccess);
